/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InstanceBulkActionExcludedInstance } from './InstanceBulkActionExcludedInstance';
import {
    InstanceBulkActionExcludedInstanceFromJSON,
    InstanceBulkActionExcludedInstanceFromJSONTyped,
    InstanceBulkActionExcludedInstanceToJSON,
} from './InstanceBulkActionExcludedInstance';
import type { InstanceBulkActionLead } from './InstanceBulkActionLead';
import {
    InstanceBulkActionLeadFromJSON,
    InstanceBulkActionLeadFromJSONTyped,
    InstanceBulkActionLeadToJSON,
} from './InstanceBulkActionLead';

/**
 * 
 * @export
 * @interface InstanceBulkActionCandidatesResponse
 */
export interface InstanceBulkActionCandidatesResponse {
    /**
     * 
     * @type {Array<InstanceBulkActionLead>}
     * @memberof InstanceBulkActionCandidatesResponse
     */
    eligible: Array<InstanceBulkActionLead>;
    /**
     * 
     * @type {Array<InstanceBulkActionExcludedInstance>}
     * @memberof InstanceBulkActionCandidatesResponse
     */
    excluded: Array<InstanceBulkActionExcludedInstance>;
}

/**
 * Check if a given object implements the InstanceBulkActionCandidatesResponse interface.
 */
export function instanceOfInstanceBulkActionCandidatesResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "eligible" in value;
    isInstance = isInstance && "excluded" in value;

    return isInstance;
}

export function InstanceBulkActionCandidatesResponseFromJSON(json: any): InstanceBulkActionCandidatesResponse {
    return InstanceBulkActionCandidatesResponseFromJSONTyped(json, false);
}

export function InstanceBulkActionCandidatesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkActionCandidatesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eligible': ((json['eligible'] as Array<any>).map(InstanceBulkActionLeadFromJSON)),
        'excluded': ((json['excluded'] as Array<any>).map(InstanceBulkActionExcludedInstanceFromJSON)),
    };
}

export function InstanceBulkActionCandidatesResponseToJSON(value?: InstanceBulkActionCandidatesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'eligible': ((value.eligible as Array<any>).map(InstanceBulkActionLeadToJSON)),
        'excluded': ((value.excluded as Array<any>).map(InstanceBulkActionExcludedInstanceToJSON)),
    };
}

